const basicColors = [
  { name: 'gray-500' },
  { name: 'red-500' },
  { name: 'yellow-500' },
  { name: 'green-500' },
  { name: 'blue-500' },
  { name: 'white' },
  { name: 'black' },
];

interface Props {
  onChange: (color: string) => void;
}

/**
 * Colorpicker component with basic tailwind color palette
 */
export const ColorPicker = ({ onChange }: Props) => {
  const handleColorChange = (color: any) => {
    onChange(color);
  };

  const getBgColor = (color: string) => {
    if (color === 'gray-500') return 'bg-gray-500 hover:bg-gray-700';
    if (color === 'red-500') return 'bg-red-500 hover:bg-red-700';
    if (color === 'yellow-500') return 'bg-yellow-500 hover:bg-yellow-700';
    if (color === 'green-500') return 'bg-green-500 hover:bg-green-700';
    if (color === 'blue-500') return 'bg-blue-500 hover:bg-blue-700';
    if (color === 'white') return 'bg-white';
    if (color === 'black') return 'bg-black';
  };

  return (
    <div>
      <div className="flex">
        {basicColors.map((color) => {
          const bgColor = getBgColor(color.name);
          return (
            <div
              key={color.name}
              className={`w-10 h-10 rounded-full mr-2 cursor-pointer ${bgColor} border`}
              onClick={() => handleColorChange(color.name)}
            />
          );
        })}
      </div>
    </div>
  );
};
